export const progressKeys = {
  all: ['progress'] as const,
  byEmployee: (employeeGuid: string) => [progressKeys.all, employeeGuid],
  byCategory: (employeeGuid: string, categoryGuid: string) => [...progressKeys.all, 'category', employeeGuid, categoryGuid] as const,
  //   categories: ['categories'] as const,
};
